type ExportButtonProps = {
  filename: string;
  payload: unknown;
  disabled?: boolean;
};

export function ExportButton({ filename, payload, disabled }: ExportButtonProps) {
  function handleClick() {
    const blob = new Blob([JSON.stringify(payload, null, 2)], { type: "application/json;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    anchor.click();
    URL.revokeObjectURL(url);
  }

  return (
    <button className="button button--secondary" type="button" onClick={handleClick} disabled={disabled}>
      Exportar JSON
    </button>
  );
}
